import React from 'react';
import { ChartTooltip as FDChartTooltip } from '@facet-wealth/design';
import PropTypes from 'prop-types';

export const ChartTooltip = ({
  seriesDataPoints,
  rangeDataPointSets,
}) => {
  let title;
  if (seriesDataPoints && seriesDataPoints.length > 0) {
    title = seriesDataPoints[0]?.dataPoint?.formattedX();
  }

  return (
    <FDChartTooltip
      title={title}
      seriesDataPoints={seriesDataPoints}
      rangeDataPointSets={rangeDataPointSets}
    />
  );
};

ChartTooltip.defaultProps = {
  seriesDataPoints: [],
  rangeDataPointSets: [],
};

ChartTooltip.propTypes = {
  seriesDataPoints: PropTypes.array,
  rangeDataPointSets: PropTypes.array,
};
